import { useTable } from "react-table";
import React from 'react';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';

const PREDEFINED_ACTIONS = {
    view: { label: 'Ver detalles', icon: <FaEye /> },
    edit: { label: 'Editar', icon: <FaEdit />, style: { color: '#007bff' } },
    delete: { label: 'Eliminar', icon: <FaTrash />, style: { color: '#dc3545' } },
};


const GenericTable = ({ columns, data, isLoading, actionList, actionHandlers }) => {
    const tableColumns = React.useMemo(() => {
        const allColumns = [...columns];

        if (actionList && actionList.length > 0 && actionHandlers) {
            allColumns.push({
                Header: 'Acciones',
                accessor: 'acciones',
                Cell: ({ row }) => (
                    <div className="table-action-buttons">
                        {actionList.map((actionName) => {
                            const actionConfig = PREDEFINED_ACTIONS[actionName];
                            const handler = actionHandlers[actionName];

                            if (!actionConfig || !handler) {
                                console.warn(`Action "${actionName}" is not defined or has no handler.`);
                                return null;
                            }

                            return (
                                <button
                                    key={actionName}
                                    className='action-btn'
                                    style={actionConfig.style}
                                    onClick={() => handler(row.original)}
                                    title={actionConfig.label}
                                >
                                    {actionConfig.icon}
                                </button>
                            );
                        })}
                    </div>
                ),
            });
        }
        return allColumns;
    }, [columns, actionList, actionHandlers]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data });

    return (
        <div className="table-container">
            {isLoading && (
                <div className="table-loading-overlay">
                    <div className="table-loading-content">
                        <div className="table-spinner"></div>
                        <span>Cargando nuevos datos...</span>
                    </div>
                </div>
            )}
            <table {...getTableProps()} className={`tabla ${isLoading ? 'loading' : ''}`}>
                <thead>
                    {headerGroups?.map((headerGroup) => {
                        const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                        return (
                            <tr key={key} {...headerGroupProps}>
                                {headerGroup.headers.map((column) => {
                                    const { key, ...columnProps } = column.getHeaderProps();
                                    return (
                                        <th
                                            key={key}
                                            {...columnProps}
                                            className={column.id === 'acciones' ? 'table-actions-column' : undefined}
                                        >
                                            {column.render("Header")}
                                        </th>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows?.map((row) => {
                        prepareRow(row);
                        const { key, ...rowProps } = row.getRowProps();
                        return (
                            <tr key={key} {...rowProps}>
                                {row.cells.map((cell) => {
                                    const { key, ...cellProps } = cell.getCellProps();
                                    return (
                                        <td
                                            key={key}
                                            {...cellProps}
                                            className={cell.column.id === 'acciones' ? 'table-actions-column' : undefined}
                                        >
                                            {cell.render("Cell")}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    {/* El mensaje para tabla vacía: */}
                    {rows?.length === 0 && !isLoading && (
                        <tr>
                            <td colSpan={tableColumns.length} style={{ textAlign: "center" }}>
                                No hay datos disponibles
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default GenericTable;
